import BaseSchema from "./base";
import { isEqual } from "lodash";
import LINES from "@/db/enums/lines";

class Sample extends BaseSchema {
  static primaryKey = "uuid";
  static tableName = "samples";
  static fields = [
    "uuid",
    "mainParameters",
    "secondParameter",
    "createdAt",
    "updatedAt",
    "previousSample",
    "nextSample",
    "phase",
    "number",
  ];

  static relatedFields = {
    mainParametersObjects: {
      m2m: true,
      owner: true,
      relatedKey: "mainParameters",
      tableName: "parameters",
    },
    secondParameterObject: {
      field: "secondParameter",
      tableName: "parameters",
      blank: true,
    },
    phaseObject: {
      field: "phase",
      tableName: "phases",
    },
  };

  static dateFields = ["createdAt", "updatedAt"];

  async getNumber() {
    if (!this.previousSample) {
      return 1;
    }
    const previousSample = await this.db.samples.get(this.previousSample);
    if (!isEqual(this.mainParameters, previousSample.mainParameters)) {
      return 1;
    }
    const nb = await previousSample.getNumber();
    return nb + 1;
  }

  async getLineType() {
    await this.setRelationships();
    if (this.mainParametersObjects[0].line == LINES.LIGNE_SECONDAIRE)
      return LINES.LIGNE_SECONDAIRE;
    return LINES.LIGNE_PRINCIPALE;
  }

  async hasSecondParameter() {
    return !!this.secondParameter;
  }

  formatParameters(delemiter = " + ") {
    if (this.mainParametersObjects == undefined)
      throw new Error(
        "Main parameters not set, you must call setRelationShips"
      );
    return this.mainParametersObjects.map(({ name }) => name).join(delemiter);
  }

  async isDioxOrHap() {
    await this.setRelationships();
    return this.mainParametersObjects.some((p) =>
      p.categories.includes("DIOX/HAP")
    );
  }

  async isChromeViGaz() {
    await this.setRelationships();
    return this.mainParametersObjects.some((p) => {
      const name = (p.name ?? "").toLowerCase();
      return (
        /(chrome|cr)[\s-]*(vi\b|hexavalent)/.test(name) && name.includes("gaz")
      );
    });
  }

  isMainLine() {
    if (!this.mainParametersObjects) {
      throw new Error("Main parameters not set");
    }
    return this.mainParametersObjects.some(
      (p) => p.line == LINES.LIGNE_PRINCIPALE
    );
  }

  get str() {
    return this.formatParameters(", ");
  }
}

export default Sample;
